import { Skeleton } from 'antd';
import { memo } from 'react';
import Masonry from 'react-masonry-css';
import { useTheme } from 'styled-components';

import { StyledCardPlaceholder, StyledWrapper } from './Grid.style';

const PLACEHOLDER_SIZES = [80, 100, 150, 180, 220];

const getPlaceholderRandomSize = () => {
  return PLACEHOLDER_SIZES[Math.floor(Math.random() * PLACEHOLDER_SIZES.length)];
};

export type GridPlaceholderType = 'node' | 'image';

export const GridPlaceholderCard = memo(
  ({ size, type }: { size?: number; type?: GridPlaceholderType }) => {
    const theme = useTheme();
    const style = {
      width: '100%',
      minWidth: '100%',
      height: size || getPlaceholderRandomSize(),
      borderRadius: theme.Border.Radius.Medium,
    };

    return (
      <StyledCardPlaceholder>
        {type === 'node' ? (
          <Skeleton.Node style={style} active={true} />
        ) : (
          <Skeleton.Image style={style} active={true} />
        )}
      </StyledCardPlaceholder>
    );
  }
);

export const GridPlaceholder = memo(
  ({
    columns = 2,
    quantity = 10,
    size,
    type,
  }: {
    columns?: number;
    quantity?: number;
    size?: number;
    type?: GridPlaceholderType;
  }) => {
    return (
      <StyledWrapper>
        <Masonry
          breakpointCols={columns}
          className="masonry-asset-grid"
          columnClassName="masonry-asset-grid-column"
        >
          {Array.from({ length: quantity }).map((_, index) => (
            <GridPlaceholderCard
              key={`grid-placeholder-${index}`}
              size={size}
              type={type || 'image'}
            />
          ))}
        </Masonry>
      </StyledWrapper>
    );
  }
);
